import { render, staticRenderFns } from "./ExpenseDelete.vue?vue&type=template&id=8ea8e56c"
import script from "./ExpenseDelete.vue?vue&type=script&lang=js"
export * from "./ExpenseDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports